import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Mail, X } from "lucide-react";
import { toast } from "sonner";

// One-time, dismissible opt-in prompt (explicit consent). Declining records the decision
// and never limits platform access. Not shown once the user has decided.
export function EmailConsentPrompt() {
  const { user } = useAuth();
  const [prefs, setPrefs] = useState(null);
  useEffect(() => {
    if (user && ["creator", "business"].includes(user.role)) {
      api.get("/me/email-preferences").then((r) => setPrefs(r.data)).catch(() => setPrefs(null));
    }
  }, [user]);
  if (!prefs || !prefs.prompt_needed) return null;

  const optIn = async () => { await api.post("/me/email-preferences", { promotional: true }); setPrefs(null); toast.success("You're subscribed to Nearfluence updates"); };
  const decline = async () => { await api.post("/me/email-consent/decline"); setPrefs(null); };

  return (
    <div data-testid="email-consent-prompt" className="fixed inset-x-0 bottom-3 z-[54] mx-auto flex w-[calc(100%-1.5rem)] max-w-md items-start gap-3 rounded-2xl border border-emerald-200 bg-white/95 p-4 shadow-xl backdrop-blur-xl">
      <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-emerald-600 text-white"><Mail className="h-4 w-4" /></div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-zinc-900">Stay in the loop?</p>
        <p className="mt-0.5 text-xs text-zinc-600">{prefs.wording || "Email me about Nearfluence news, features and offers. You can unsubscribe anytime."}</p>
        <div className="mt-2.5 flex gap-2">
          <Button size="sm" data-testid="consent-optin" onClick={optIn} className="rounded-full bg-emerald-600 hover:bg-emerald-700">Yes, email me</Button>
          <Button size="sm" variant="ghost" data-testid="consent-decline" onClick={decline} className="rounded-full text-zinc-500">No thanks</Button>
        </div>
        <p className="mt-1 text-[11px] text-zinc-400">Essential account emails are always sent regardless.</p>
      </div>
      <button data-testid="consent-close" onClick={decline} className="shrink-0 rounded-full p-1 text-zinc-400 hover:bg-zinc-100"><X className="h-4 w-4" /></button>
    </div>
  );
}
